"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Home = _interopRequireDefault(require("@/components/FormGenerator/index/Home.vue"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
var _default = {
  components: {
    configList: _Home.default
  },
  // name: "configList",
  props: {
    prentData: {
      type: Object,
      default: {}
    }
  }
};
exports.default = _default;